/**
 * DICOM 문자열을 한글로 되돌린다. (2026-11-04)
 * dicom-parser 는 바이트 하나를 글자 하나로 읽어서(latin1) 한글 이름이 "È«^±æµ¿" 처럼 깨진다.
 * 바이트로 되돌린 뒤 UTF-8(ISO_IR 192) → 안 되면 EUC-KR(ISO_IR 149, ISO 2022 IR 149) 로 읽는다.
 * 영문·숫자만 있는 값은 그대로 돌려준다.
 */
export function decodeDicomText(str) {
  if (str === undefined || str === null) return str;
  const s = String(str);
  if (!/[\u0080-ÿ\u001b]/.test(s)) return s; // 영문·숫자만 있으면 그대로
  if (/[^\u0000-ÿ]/.test(s)) return s; // 이미 제대로 읽힌 글자
  const bytes = Array.from(s, (c) => c.charCodeAt(0));
  // ISO 2022 의 문자셋 전환 표시(ESC $ ) C 등)는 빼고 읽는다
  const clean = [];
  for (let i = 0; i < bytes.length; i++) {
    if (bytes[i] === 0x1b) {
      i++;
      while (i < bytes.length && bytes[i] >= 0x20 && bytes[i] <= 0x2f) i++;
      continue; // 마지막 표시 바이트(0x40~0x7e)는 for 의 i++ 로 건너뜀
    }
    clean.push(bytes[i]);
  }
  const u8 = Uint8Array.from(clean);
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(u8);
  } catch (e) {
    // UTF-8 이 아니면 아래 EUC-KR
  }
  try {
    return new TextDecoder("euc-kr").decode(u8);
  } catch (e) {
    return s;
  }
}

export default decodeDicomText;
